import _ from "lodash";

export default {
    keyForIds(ids: Array<string>) {
        return _.reduce(ids, (total, n) => {
            const a = String(n);
            return total + parseInt(a.replace(/\D/g, ""), 10);
        });
    }
};
